import { createStyles } from 'antd-style';
import MDEditor from '@uiw/react-md-editor';
import React from 'react';

interface MarkdownEditorProps {
  /** 当前值（Markdown 字符串） */
  value?: string;
  /** 值变化回调 */
  onChange?: (value: string) => void;
  /** 占位符 */
  placeholder?: string;
  /** 是否禁用 */
  disabled?: boolean;
  /** 编辑器高度 */
  height?: number;
  /** 预览模式：edit | live | preview */
  preview?: 'edit' | 'live' | 'preview';
}

const useStyles = createStyles(({ token }) => ({
  container: {
    width: '100%',
    '.w-md-editor': {
      borderRadius: token.borderRadius,
      borderColor: token.colorBorder,
      backgroundColor: token.colorBgContainer,
    },
    '.w-md-editor-toolbar': {
      borderColor: token.colorBorder,
      backgroundColor: token.colorBgContainer,
    },
    '.w-md-editor-content': {
      backgroundColor: token.colorBgContainer,
    },
    '.w-md-editor-preview': {
      backgroundColor: token.colorBgContainer,
    },
    // 禁用状态
    '&.disabled': {
      '.w-md-editor': {
        backgroundColor: token.colorBgContainerDisabled,
        pointerEvents: 'none',
        opacity: 0.6,
      },
    },
  },
}));

/**
 * Markdown 编辑器组件
 * 基于 @uiw/react-md-editor，支持实时预览
 */
const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value = '',
  onChange,
  placeholder = '请输入 Markdown 内容...',
  disabled = false,
  height = 300,
  preview = 'live',
}) => {
  const { styles, cx } = useStyles();

  const handleChange = (val?: string) => {
    onChange?.(val || '');
  };

  return (
    <div className={cx(styles.container, disabled && 'disabled')} data-color-mode="light">
      <MDEditor
        value={value}
        onChange={handleChange}
        height={height}
        preview={preview}
        textareaProps={{
          placeholder,
          disabled,
        }}
      />
    </div>
  );
};

export default MarkdownEditor;
